import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProdutoDocumentoService } from '../../../services/produto-documento.service';

@Component({
  selector: 'app-produto-documento-edit',
  templateUrl: './produto-documento-edit.component.html',
  styleUrls: ['./produto-documento-edit.component.scss']
})
export class ProdutoDocumentoEditComponent extends BaseFormComponent<any> implements OnInit {

  actionLabel: string = "Novo";

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: ProdutoDocumentoService,
    private navigation: NavigationService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
    });

    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back([`/pre-projeto/admin/produto-documento`]);
  }

  getDataCreate() {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar() {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: any) => {
              this.msgSuccess('Cadastrado alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: any) => {
              this.confirmation('Cadastrado com sucesso!').subscribe(() => {
                this.navigation.replace(['/pre-projeto', 'admin', 'produto-documento']);
              });
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }
}

